import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'clsx';

import * as commonSelectors from '../../redux/selectors/common';
import { validateSourceCache } from '@/modules/common/helpers/videoCache';
import { updateResourcesStartedAction } from '@/modules/common/redux/slices/common';

import styles from './VideoThumbnail.module.scss';

type Props = {
  previewUrl: string;
  className?: string;
  isHovered?: boolean;
  cover?: boolean;
};

function VideoThumbnail({ previewUrl, isHovered = false, cover = true, className = '' }: Props) {
  const dispatch = useDispatch();
  const delayPreview = useSelector(commonSelectors.delayPreviewSelector);
  const videoPreview = useSelector(commonSelectors.videoPreviewSelector);
  const timer = useRef<number | undefined>(undefined);

  const [showPreview, setPreviewState] = useState(false);

  useEffect(() => {
    if (isHovered && videoPreview) {
      validateSourceCache(previewUrl, (params) => {
        dispatch(updateResourcesStartedAction(params));
      });
      timer.current = window.setTimeout(() => setPreviewState(true), delayPreview);
    }

    if (!isHovered) {
      clearTimeout(timer.current);
      setPreviewState(false);
    }
  }, [isHovered, videoPreview, delayPreview]);

  useEffect(
    () => () => {
      clearTimeout(timer.current);
    },
    [],
  );

  return (
    videoPreview &&
    showPreview &&
    previewUrl && (
      <video
        className={classNames(styles.Video, className, {
          [styles.Video___cover]: cover ?? true,
        })}
        autoPlay
        muted
        src={previewUrl}
      />
    )
  );
}

VideoThumbnail.propTypes = {
  previewUrl: PropTypes.string,
  className: PropTypes.string,
  isHovered: PropTypes.bool,
  cover: PropTypes.bool,
};

export default VideoThumbnail;
